import { Card, CardBody, Pill, ReadOnlyValue, SourceSection } from '@/shared/components';
import type { PropertyResponse } from '@/shared/api';
import { formatDateTime } from '@/shared/lib/format';

interface SystemMetaCardProps {
  propertyId: string;
  property: PropertyResponse | undefined;
}

export function SystemMetaCard({ propertyId, property }: SystemMetaCardProps) {
  return (
    <Card className="mb-6">
      <CardBody className="p-6">
        <SourceSection
          source="system"
          trailing={
            property && (
              <Pill size="sm" variant={property.isActive ? 'accent' : 'outline'}>
                {property.isActive ? 'Aktiv' : 'Pausiert'}
              </Pill>
            )
          }
        />
        <dl className="divide-line/40 divide-y">
          <ReadOnlyValue label="Kennung" value={propertyId} mono copyable={propertyId} />
          <ReadOnlyValue
            label="Kürzel"
            value={property?.slug ?? 'nicht hinterlegt'}
            mono
            copyable={property?.slug}
          />
          <ReadOnlyValue
            label="Kennung beim Kanalmanager (Objekt)"
            value={property?.channexPropertyId ?? 'nicht hinterlegt'}
            mono
            copyable={property?.channexPropertyId ?? undefined}
          />

          {property && (
            <ReadOnlyValue label="Erstellt" value={formatDateTime(property.createdAt)} />
          )}
          {property?.updatedAt && (
            <ReadOnlyValue label="Zuletzt geändert" value={formatDateTime(property.updatedAt)} />
          )}
        </dl>
      </CardBody>
    </Card>
  );
}
